export default {"src":"/_next/static/media/guarantee-back.dd3ae704.svg","height":176,"width":478,"blurWidth":0,"blurHeight":0};